import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEpelComponent } from './simple-icons-epel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEpelComponent ],
    exports:      [ SimpleIconsEpelComponent ],
    bootstrap:    []
})
export class SimpleIconsEpelModule {}
